import { useEffect, useState } from "react";
import { Building2 } from "lucide-react";
import { validateHotel, getCachedHotel, isHotelModeActive } from "./hotelClient";

// Small pill placed right beside the existing personal Google Sign-in pill.
// Personal Google sign-in stays completely unchanged. This button ONLY opens
// the organisation selector page — it never interferes with personal auth.
export default function OrgSignInPill({ onOpen }) {
  const [hotel, setHotel] = useState(() => getCachedHotel());

  useEffect(() => {
    let alive = true;
    validateHotel().then((h) => { if (alive) setHotel(h); });
    const onChange = () => {
      validateHotel().then((h) => { if (alive) setHotel(h); });
    };
    window.addEventListener("pt_hotel_changed", onChange);
    return () => {
      alive = false;
      window.removeEventListener("pt_hotel_changed", onChange);
    };
  }, []);

  if (hotel && isHotelModeActive()) {
    // Compact "Hotel Mode" badge — kids never see it, staff see a small pill.
    return (
      <button
        type="button"
        onClick={onOpen}
        data-testid="org-hotel-mode-pill"
        className="inline-flex items-center gap-1.5 bg-[#FFF7D6] backdrop-blur-md text-[#7A5A00] hover:bg-[#FFEEB0] px-2 sm:px-3 py-1.5 rounded-full text-xs font-medium shadow-md border border-white/60 transition-all sm:gap-2 sm:px-4 sm:text-sm"
        title={`Hotel Mode • ${hotel.hotel_name || ''}`}
      >
        <Building2 className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
        <span className="hidden sm:inline">Hotel Mode</span>
        <span className="ml-1 text-[10px] sm:text-xs font-semibold text-[#5A4A00]/80">
          {(hotel.total_available ?? 0).toLocaleString()}
        </span>
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={onOpen}
      data-testid="org-signin-pill"
      className="inline-flex items-center gap-1.5 bg-white/85 backdrop-blur-md text-[#4A4A4A] hover:text-[#A55B64] hover:bg-white px-2 sm:px-3 py-1.5 rounded-full text-xs font-medium shadow-md border border-white/60 transition-all sm:gap-2 sm:px-4 sm:text-sm"
      title="Hotels, Schools & Organisations sign-in"
    >
      <Building2 className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
      <span className="hidden sm:inline">Organisation Sign In</span>
      <span className="sm:hidden">Org</span>
    </button>
  );
}
